import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import get from "lodash.get";
import BWModels from "@benjamin-west-rpm2/benjamin-west-models";

import { FormikForm, ActionButtons } from "../../../../forms";
import SelectWithError from "../../../../inputs/SelectWithError";
import SelectContactRow from "./SelectContactRow";
import AddressBookContact from "../../../../../models/AddressBookContact";
import { inputs } from "../../../../inputs/inputConfigs";
import CheckboxRow from "../CheckboxRow";

export const consultingCompanyContactsDataComponentId =
  "ConsultingCompanyContacts";

const selectContactInput = (consultingCompanyId, scopeId) => ({
  InputComponent: SelectWithError,
  name: "contactId",
  label: "Select Contact",
  dataComponentId: "select-address-book-consultant-contact",
  APIOptions: {
    model: AddressBookContact,
    route: "address-book-contacts",
    includes: ["contact"],
    sort: [{ columnName: "contact.name", direction: "asc" }],
    rootFilters: {
      $where: {
        "addressBook.type": "Consultants",
        "contact.status": { $notEqual: "inact" },
        "scope.id": scopeId,
      },
    },
    params: { omitInConsultingCompany: consultingCompanyId },
    fetchOnlyOnce: true,
    omitFilterScopeModels: true,
    pageSize: -1,
  },
  apiFilterLabelProperty: "contact.name",
  labelProperty: addressBookContact =>
    get(addressBookContact, "contact.name", ""),
  valueProperty: "contactId",
  fullWidth: true,
  isAutocomplete: true,
  isAutocompleteMulti: false,
  required: true,
});

export const GroupWrapper = styled.div`
  padding: 24px 0px;
`;

export default class SelectFromAddressBookForm extends Component {
  static propTypes = {
    onSubmit: PropTypes.func,
    consultingCompany: PropTypes.object.isRequired,
    toggleCreateNewContact: PropTypes.func.isRequired,
  };

  render() {
    const { onSubmit, consultingCompany, toggleCreateNewContact } = this.props;

    return (
      <FormikForm
        initialValues={{
          consultingCompanyId: consultingCompany.id,
          canAccessClientPortal: false,
          isActive: true,
        }}
        onSubmit={onSubmit}
        validationSchema={BWModels.loadSchema("ConsultingCompanyContact")}
      >
        {({ handleSubmit }) => (
          <React.Fragment>
            <GroupWrapper>
              <SelectContactRow
                input={selectContactInput(
                  consultingCompany.id,
                  consultingCompany.scopeId
                )}
                handleToggleCreateNewContact={toggleCreateNewContact}
              />
              <CheckboxRow
                isFirst
                input={inputs.canAccessClientPortal}
                label={inputs.canAccessClientPortal.label}
              />
              <CheckboxRow
                input={inputs.contactIsActiveForConsultingCompany}
                label={inputs.contactIsActiveForConsultingCompany.label}
              />
            </GroupWrapper>
            <ActionButtons
              isModal={true}
              onSend={handleSubmit}
              listeners={[consultingCompanyContactsDataComponentId]}
            />
          </React.Fragment>
        )}
      </FormikForm>
    );
  }
}
